import { supabase } from '@/integrations/supabase/client';

const PAGE_SIZE = 1000;
const MAX_PAGES = 200;

interface Options {
  deviceIds?: string[];
  deviceId?: string;
  start: string;
  end: string;
}

/**
 * PostgREST caps an unbounded select at 1000 rows, which silently drops older
 * devices from busy windows. Page through the range so every device's activity
 * is represented.
 */
export async function fetchTriggerRange({ deviceIds, deviceId, start, end }: Options) {
  const all: any[] = [];
  for (let page = 0; page < MAX_PAGES; page++) {
    let query = supabase
      .from('led_triggers')
      .select('id, device_id, created_at, message')
      .gte('created_at', start)
      .lte('created_at', end)
      .order('created_at', { ascending: false })
      .range(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE - 1);

    if (deviceId) query = query.eq('device_id', deviceId);
    if (deviceIds?.length) query = query.in('device_id', deviceIds);

    const { data, error } = await query;
    if (error) throw error;
    if (!data?.length) break;
    all.push(...data);
    if (data.length < PAGE_SIZE) break;
  }
  return all;
}
